import ICONS from '@/shared/entities/constants/icons';
import React, { ReactNode, useState } from 'react';
import { Button, FloatLayer, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface PhonePreviewProps {
  label?: string;
  children?: ReactNode;
}

export const PhonePreview: React.FC<PhonePreviewProps> = ({ label, children }) => {
  const [showLayer, setShowLayer] = useState(false);

  return (
    <Grid column>
      <Grid gap={8} alignItems='center' stretch alignContent='right'>
        {label && <Text value={label} size='medium' />}

        <Button
          testId='phone-preview-help-button'
          icon={ICONS.HELP}
          solo
          size='larger'
          iconColor='light'
          onClick={() => setShowLayer(!showLayer)}
        />
      </Grid>

      <div
        style={{
          width: 350,
        }}>
        <FloatLayer
          rounded
          full
          show={showLayer}
          closeClickOutside
          elevation={4}
          onClose={() => setShowLayer(false)}>
          <div
            style={{
              border: '6px solid #E6EAED',
              borderRadius: 12,
              width: 'calc(100% - 48px)',
              margin: 24,
              background: '#fff',
            }}>
            {children}
          </div>
        </FloatLayer>
      </div>
    </Grid>
  );
};
